import { render, staticRenderFns } from "./Ertiga.vue?vue&type=template&id=2376a5fa&"
import script from "./Ertiga.vue?vue&type=script&lang=ts&"
export * from "./Ertiga.vue?vue&type=script&lang=ts&"
import style0 from "./Ertiga.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports